define('viewmodels/modals/alerts/GameMessagesAlert',[],function () {

    var GameMessagesAlert = function(dialog, messages) {
        this.dialog = dialog;

        this.messages = messages;

        this.options = {
            transitions: {
                in: '',
                out: ''
            }
        };

        this.close = function() {
            dialog.close();
        };
    };

    return GameMessagesAlert;
});

